/**
 * WebAssembly初始化脚本
 * 在应用启动时预加载和配置WebAssembly
 */

import WasmLoader from "./wasmLoader";

// 需要预加载的WASM文件列表
const WASM_FILES = [
  "/2d-st/mxdrawassembly_minst.wasm",
  // 可以在这里添加其他需要预加载的wasm文件
];

/**
 * 初始化WebAssembly配置
 * 在应用启动时调用
 */
export function initWebAssembly() {
  // 预加载所有WASM文件
  WasmLoader.preloadWasmModules(WASM_FILES);
}

export default {
  initWebAssembly,
};
